import React                from "react";
import PropTypes            from 'prop-types';
import VXButton             from "../SimpleElements/VXButton/VXButton";
import {COLOR_TYPE_SPECIAL} from "../SimpleElements/VXButton/ButtonHelper";
import {VXButtonLineConfig} from "../SimpleElements/VXButton/VXButtonConfig";
import Translations         from "../../utils/Translations";
import STYLES               from "../SimpleElements/VXButton/EnumVXButton";

export default function FilterNoResult({resetFilter, fullHeight, headlineText, sublineText}) {
    return <div className={"cams__no-result" + (fullHeight ? ' cams__no-result--margin' : '')}>
        <div className="cams__no-result-headline">{headlineText}</div>
        <div className="cams__no-result-subline">{sublineText}</div>
        <VXButton color={COLOR_TYPE_SPECIAL}
                  line1={[new VXButtonLineConfig(Translations.get('ResetFilter'))]}
                  onClick={() => resetFilter()}
                  size={STYLES.SIZE.SMALL}
        />
    </div>;
}

FilterNoResult.propTypes = {
    resetFilter:  PropTypes.func,
    fullHeight:   PropTypes.bool,
    headlineText: PropTypes.string,
    sublineText:  PropTypes.string,
};
